export default __webpack_public_path__ + "static/media/MedidasReefer20.6b6b5017.png";